// extracted by mini-css-extract-plugin
export var hero = "Hero-module--hero--e2243";
export var heroPlaceholder = "Hero-module--heroPlaceholder--561ed";
export var heroVideo = "Hero-module--heroVideo--a588a";